const defaultTarget = 'memory';
export function createDataView(data) {
    const proxyName = 'Proxy';
    return (window[proxyName] &&
        new Proxy(data, {
            get(target, name) {
                const item = target[name];
                return item && item.value;
            },
            set(_target, _name, _value) {
                return true;
            },
        }));
}
export function createDataOptions(options = defaultTarget) {
    if (typeof options === 'string') {
        return {
            target: options,
        };
    }
    else if (options && typeof options === 'object' && !Array.isArray(options)) {
        return options;
    }
    else {
        return {
            target: defaultTarget,
        };
    }
}
export function getDataExpiration(expires) {
    if (typeof expires === 'number') {
        return expires;
    }
    else if (expires instanceof Date) {
        return expires.valueOf();
    }
    return -1;
}
//# sourceMappingURL=data.js.map